import { render, staticRenderFns } from "./PredictionScore.vue?vue&type=template&id=b4cbc860&"
import script from "./PredictionScore.vue?vue&type=script&lang=ts&"
export * from "./PredictionScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports